export default {
  nav: {
    main: 'Main',
    ordersAndInvoices: 'Orders and Invoices',
    drafts: 'Drafts',
    automation: 'Automation',
    workspace: 'Workspace',
    templates: 'Templates',
    delivery: 'Delivery',
    settings: 'Settings',
    shippingLabels: 'Shipping Labels',
    subscriptions: 'Subscriptions',
    support: 'Support',
    developer: 'Developer',
    writeReview: 'Write a Review',
    supportTicket: 'Support Ticket',
    welcomeTour: 'Welcome Tour',
    administratorConsole: 'Administrator Console',
    logout: 'Logout',
  },
  dashboard: {
    pageTitle: 'Orders and Invoices',
    pageDescription: 'Manage your orders and invoices',
    title: 'Orders and Invoices',
    selectedOrders: '{count} selected orders',
    completed: '% completed',
    processing: 'Processing, please wait...',
    bulkDownload: 'Bulk Download',
    upgradeBulkDownload: 'Upgrade your plan for Bulk Download',
    showFilters: 'Show Filters',
    hideFilters: 'Hide Filters',
    creatingInvoices: 'Creating invoices, please wait...',
    bulkCreateInvoices: 'Bulk Create Invoices',
    cannotCreateAutopilot: 'You cannot manually create invoices when invoicing mode is on auto-pilot.',
    exportInvoices: 'Export invoices or orders',
    capturePayments: 'Capture Payments Manually',
    filterOrders: 'Filter orders',
    error: 'Hey, something went wrong...',
    close: 'Close',
    chooseDate: 'Choose a date',
    chooseIssueDate: 'Choose an issue date for the selected invoices',
    cancel: 'Cancel',
    createInvoices: 'Create Invoices',
    storno: 'Storno',
    bulkOrderCapture: 'Bulk Order Capture',
  },
  search: {
    createdBetween: 'Created btw.',
    modifiedBetween: 'Modified btw.',
    orderNumber: 'Order #',
    invoiceNumber: 'Invoice #',
    refundNumber: 'Refund #',
    customer: 'Customer',
    payment: 'Payment',
    any: 'Any',
    authorized: 'Authorized',
    pending: 'Pending',
    paid: 'Paid',
    partiallyPaid: 'Partially Paid',
    refunded: 'Refunded',
    voided: 'Voided',
    partiallyRefunded: 'Partially Refunded',
    unpaid: 'Unpaid',
    fulfillment: 'Fulfillment',
    fulfilled: 'Fulfilled',
    partial: 'Partial',
    unfulfilled: 'Unfulfilled',
    loading: 'Loading orders...',
    search: 'Search',
  },
  orderList: {
    noCustomer: 'No Customer',
    downloadOrder: 'Download Order',
    deleteWarning: 'Important! This will delete all the invoices and refunds created after the date:',
    includingInvoice: 'including the selected invoice #',
    pressOk: 'Press OK to continue or Cancel to abort.',
    cannotCreateAutopilot: 'You cannot manually create invoices when invoicing mode is on auto-pilot.',
    createInvoice: 'Create invoice for this order',
    cannotCreateCustomerInvoicing: 'Invoicing is disabled for this customer.',
    create: 'Create',
    add: 'Add',
    addCreditNote: 'Add Credit Note',
    createStorno: 'Create a Storno Invoice',
    refund: 'Refund',
    downloadInvoice: 'Download this invoice',
    download: 'Download',
    default: 'Default',
    legacyTemplate: 'Invoice, Storno and Credit Note (Default) - deprecated',
    downloadStorno: 'Download this storno/credit note',
    fulfillOrder: 'Fulfill Order',
    close: 'Close',
    orderNum: 'Order #',
    locPrefix: 'Loc Prefix',
    invoiceNum: 'Invoice #',
    refundNum: 'Refund #',
    customerCol: 'Customer',
    orderCreatedDate: 'Order Created Date',
    orderModifiedDate: 'Order Modified Date',
    delivered: 'Delivered',
    paymentStatus: 'Payment Status',
    fulfillmentStatus: 'Fulfillment Status',
    totalOutstanding: 'Total Outstanding Amount',
    originalPrice: 'Original Price',
    noOrders: 'Your store has no orders for the selected status.',
    cannotCreateNoOrders: 'You cannot create invoices when are no orders.',
    createOrdersFirst: 'Please create at least one order and try again.',
    createOrders: 'Create orders',
    loadingOrders: 'Loading...',
    paidManual: 'Paid - Manual',
    paid: 'Paid',
    refunded: 'Refunded',
    pending: 'Pending',
    partiallyPaid: 'Partially Paid',
    partiallyRefunded: 'Partially Refunded',
    fulfilled: 'Fulfilled',
    unfulfilled: 'Unfulfilled',
    deliveryPending: 'Pending',
    deliverNow: 'Deliver now',
    deliveryPartial: 'Partial',
    notDelivered: 'Not Delivered',
    deliverAgain: 'Deliver Again',
    deliveryDetails: 'Delivery Details',
    deliveryFailed: 'Delivery Failed',
    sent: 'Sent',
    failed: 'Failed',
    toLabel: 'To',
    folderLabel: 'Folder',
    open: 'Open',
    invoice: 'Invoice',
    creditNote: 'Credit Note',
    stornoLabel: 'Storno',
    unknown: 'Unknown',
    googleDrive: 'Google Drive',
    clientsTablet: 'Clients Tablet',
    shippyPro: 'ShippyPro',
    emailChannel: 'Email',
    ftpChannel: 'FTP',
    revertToDate: 'Revert to this date',
  },
  downloadDialog: {
    downloadType: 'Download {type}...',
    selectTemplate: 'Select one template from the gallery to export orders, invoices, storno invoices or credit notes.',
    getMoreTemplates: 'Get more Templates',
    createNewTemplate: 'Create a new Template',
    allCreatedBetween: 'All created {type} between',
    selectedType: 'Selected {type}',
    and: 'and',
    status: 'Status',
    any: 'Any',
    open: 'Open',
    closed: 'Closed',
    cancelled: 'Cancelled',
    paymentStatus: 'Payment Status',
    fulfillmentStatus: 'Fulfillment Status',
    fulfilled: 'Fulfilled',
    partial: 'Partial',
    unfulfilled: 'Unfulfilled',
    authorized: 'Authorized',
    pending: 'Pending',
    paid: 'Paid',
    partiallyPaid: 'Partially Paid',
    refunded: 'Refunded',
    voided: 'Voided',
    partiallyRefunded: 'Partially Refunded',
    unpaid: 'Unpaid',
    format: 'Format',
    forLocation: 'For Location',
    advancedOptions: 'Advanced Options',
    exportHSCodes: 'Export Inventory Harmonized System Codes (slower)',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templates: {
    pageTitle: 'Templates',
    pageDescription: 'Customize your invoice templates',
    title: 'Templates',
    installTranslated: 'Install a translated template',
    installTranslatedDesc: 'Choose a different language by clicking on this button.',
    createNew: 'Create a new template if necessary',
    createNewDesc: 'Click on this button to create a new template if needed.',
    customize: 'Customize templates',
    customizeDesc: 'Click on the default template to customize it. You can change logo, colors and for more advanced users, the code behind.',
    defaultTemplate: 'Invoice, Storno and Credit Note (Default)',
    logo: 'Logo',
    colorPalette: 'Color Palette',
    getColorPalettes: 'Get color palettes',
    paperSize: 'Paper Size',
    format: 'Format',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orientation',
    landscape: 'Landscape',
    portrait: 'Portrait',
    margin: 'Margin (cm)',
    unsavedChanges: 'Unsaved changes',
    discard: 'Discard',
    save: 'Save',
    legacyWarningTitle: "You're using the deprecated legacy template",
    legacyWarning: "Modern templates offer better features, support, and regular updates. We recommend migrating to a modern template.",
    migrateButton: "Migrate to Modern Templates",
    dismissButton: "Dismiss",
    migrationConfirmTitle: "Confirm Migration",
    migrationConfirm: "Are you sure you want to migrate? This will:",
    migrationConfirm1: "Hide the legacy template permanently",
    migrationConfirm2: "You must have at least one modern template installed",
    migrationConfirm3: "This change cannot be reverted",
    migrationConfirmNote: "Note: If you haven't installed a modern template yet, please do so before migrating.",
    cancel: "Cancel",
    migrating: "Migrating...",
    confirmMigrate: "Yes, Migrate Now",
  },
  labels: {
    pageTitle: 'Shipping Labels',
    pageDescription: 'Create and manage shipping labels',
    title: 'Shipping Labels',
    glsRequiresPro: 'GLS Shipping Labels for EEU requires the Professional plan.',
    upgradeDesc: 'Upgrade to Professional to create and manage shipping labels.',
    upgradePlan: 'Upgrade your plan',
    eeuGls: 'EEU GLS',
    enabled: 'Enabled',
    country: 'Country',
    hungary: 'Hungary',
    slovakia: 'Slovakia',
    czech: 'Czech',
    romania: 'Romania',
    slovenia: 'Slovenia',
    croatia: 'Croatia',
    senderId: 'Sender ID',
    username: 'Username',
    password: 'Password',
    name: 'Name',
    city: 'City',
    address: 'Address',
    zipCode: 'Zip Code',
    contactPerson: 'Contact Person',
    phone: 'Phone',
    email: 'Email',
    glsServices: 'GLS Services',
    expressService: 'Express Service',
    exchangeService: 'Exchange Service',
    smsService: 'SMS Service',
    smsText: 'SMS Text',
    preAdviceService: 'PreAdvice Service',
    unsavedChanges: 'Unsaved changes',
    discard: 'Discard',
    save: 'Save',
  },
  billing: {
    pageTitle: 'Billing',
    pageDescription: 'Manage your subscription and billing',
    title: 'Billing',
    subscriptionFor: 'Subscription plan for shop',
    currentlySubscribed: 'You are currently subscribed to',
    plan: 'plan',
    cancelSubscription: 'Cancel Subscription',
    upgradePlan: 'Upgrade your plan',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / month',
    upgrade: 'Upgrade',
    includesAllStarter: 'Includes all Starter features, plus:',
    proFeature1: 'Global Compliance Suite: Location-based prefixes and custom sequential numbering',
    proFeature2: 'Smart Localization: Auto-translated emails and localized PDF attachments',
    proFeature3: 'Complete B2B Document Lifecycle: Proformas, B2B Quotes, and Credit Notes',
    proFeature4: 'B2B Accounting Sync: 3-decimal unit precision and multi-currency displays',
    proFeature5: 'Automated Backups: Copy invoices automatically to secure FTP or Google Drive',
    proFeature6: 'Shopify Flow: Automate invoice generation, delivery, and storno via Flow triggers and actions',
    proFeature7: 'Advanced AI Logic: Use the on-device AI for complex conditional layout clauses',
    proFeature8: 'UBL XML & ZUGFeRD / Factur-X exports (European E-invoicing compliance)',
    proFeature9: 'EPC QR codes for instant mobile POS payments',
    proFeature10: 'GLS Shipping Labels for EEU',
    proFeature11: '7-year compliance tax retention',
    currentlyUsing: 'You are currently using our',
    free: 'free',
    subscriptionPlan: 'subscription plan.',
    monthlyUsage: 'Monthly Usage',
    monthlyGenerated: '{count} / 50 invoices this month',
    monthlyLimitReached: 'Monthly limit reached. Upgrade to Starter for unlimited invoices.',
    freePlan: 'Free Plan',
    freeToInstall: 'Free to install',
    freeFeature1: 'Up to 50 invoices/orders per month',
    freeFeature2: 'Access to all 31+ predefined templates',
    freeFeature3: 'Basic AI Copilot',
    freeFeature4: 'Standard PDF downloads & printing',
    freeFeature5: 'Standard document suite (Invoices, Packing Slips, Receipts)',
    freeFeature6: '3-month secure invoice retention',
    starterPlan: 'Starter Plan',
    starterPrice: '$9.99 / month',
    starterPricePerInvoice: '+ 3¢ per invoice created',
    subscribe: 'Subscribe',
    starterFeature1: 'Unlimited invoices & orders',
    starterFeature2: 'Automated PDF delivery via email',
    starterFeature3: 'Full access to hybrid editor & AI Copilot',
    starterFeature4: 'Shopify POS & barcode integration',
    starterFeature5: 'Shopify Flow: Triggers & actions for invoice automation',
    starterFeature6: 'UBL XML / PEPPOL & ZUGFeRD / Factur-X exports (E-invoicing compliance)',
    starterFeature7: '1-year secure invoice retention',
    proTaxOverrides: 'Custom Tax Overrides: VAT / GST per product and SKU-level rates',
    unsavedChanges: 'Unsaved changes',
    discard: 'Discard',
    save: 'Save',
  },
  autopilot: {
    pageTitle: 'Automation',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automation',
    autoCreate: 'Automatically Create Invoices',
    disabled: 'Disabled (Manual)',
    whenCreated: 'When orders are created',
    whenFulfilled: 'When orders are fulfilled',
    whenPaid: 'When orders are paid',
    autoCreateDesc: 'Invoices will be created on the date when orders are created, fulfilled or paid.',
    autoStorno: 'Automatically Storno Invoices',
    whenCancelled: 'When orders are cancelled or refunded',
    autoStornoDesc: 'Storno invoices will be created on the date when orders are voided/cancelled or refunds are created.',
    cannotAutoFree: 'Creating invoices automatically cannot be performed with the free plan.',
    upgradePlan: 'Upgrade your plan',
    unsavedChanges: 'Unsaved changes',
    discard: 'Discard',
    save: 'Save',
  },
  delivery: {
    pageTitle: 'Delivery',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Delivery',
    settings: 'Settings',
    useOrderNumbers: 'Use order numbers for files',
    sendIfCountry: 'Send if billing address country is',
    countryCodesHint: 'List all country codes separated by semicolon.',
    sendForTags: 'Send for customers who have one of the listed tags',
    tagsHint: 'List all tags separated by semicolon.',
    emailDelivery: 'Email Delivery',
    sendAsPdf: 'Send invoices as PDF attachments to customers',
    autoSend: 'Automatically send when an invoice is created',
    subject: 'Subject',
    body: 'Body',
    xmlAttachments: 'XML Attachments',
    attachUbl: 'Attach UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Attach ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Send Test Email',
    sending: 'Sending...',
    customSmtp: 'Custom SMTP Server',
    customSmtpDesc: 'Use your own mail server instead of the default',
    enableSmtp: 'Enable custom SMTP',
    smtpHost: 'SMTP Host',
    port: 'Port',
    useSsl: 'Use SSL/TLS',
    username: 'Username',
    password: 'Password',
    fromEmail: 'From Email',
    fromName: 'From Name',
    shopifyLiquid: 'Shopify Liquid Template',
    pasteInto: 'Paste this into your',
    orderConfirmation: 'order confirmation template',
    toAddLink: 'to add a download link.',
    downloadInvoice: 'Download your invoice',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Send requests to ClientsTablet when invoices are created',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Send PDF invoices as customs documents to ShippyPro for non-EU countries',
    ftpBackup: 'FTP / SFTP Backup',
    ftpDesc: 'Automatically copy invoices to your server',
    enableFtp: 'Enable automatic FTP backup',
    host: 'Host',
    useSftp: 'Use SFTP (secure)',
    destinationFolder: 'Destination folder',
    xmlFiles: 'XML Files',
    includeUbl: 'Include UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Include ZUGFeRD / Factur-X XML',
    testConnection: 'Test Connection',
    testing: 'Testing...',
    pro: 'PRO',
    upgradeFtp: 'Upgrade to Professional to automatically copy invoices to your FTP/SFTP server.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Sync invoices automatically to your Drive',
    connected: 'Connected',
    disconnect: 'Disconnect',
    notWorking: 'Not working? Go to',
    googlePermissions: 'Google Permissions',
    removeThenReconnect: 'remove Invoice Browse, then reconnect.',
    connectGoogleDrive: 'Connect Google Drive',
    upgradeGoogleDrive: 'Upgrade to Professional to automatically sync invoices to Google Drive.',
    unsavedChanges: 'Unsaved changes',
    discard: 'Discard',
    save: 'Save',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
  },
  bookkeeping: {
    pageTitle: 'Settings',
    pageDescription: 'Configure your invoice settings',
    title: 'Settings',
    owner: 'Owner',
    email: 'Email',
    phone: 'Phone',
    keepDifferentNumbering: 'Keep different invoice numbering for each order location',
    keepDifferentNumberingDisabled: 'Keep different invoice numbering for each order location is not available on your plan.',
    locationEmailDesc: 'This allows you to send emails and invoices translated based on the order location: inventory location, shipping or billing address',
    upgradePlan: 'Upgrade your plan',
    matchingCriteria: 'Matching Criteria',
    locationId: 'Location Id',
    shippingCountryCode: 'Shipping Address Country Code',
    billingCountryCode: 'Billing Address Country Code',
    matchLocationDesc: 'Match a location based on order location id, shipping or billing address country code.',
    companyInfo: 'Company Information',
    name: 'Name',
    website: 'Website',
    registrationNumber: 'Registration Number',
    taxId: 'Tax Id',
    addressSection: 'Address',
    streetName: 'Street Name',
    streetNumber: 'Street Number',
    zip: 'Zip',
    city: 'City',
    region: 'Region',
    country: 'Country',
    bankingInfo: 'Banking Information',
    bankName: 'Bank Name',
    swift: 'Swift',
    currency: 'Currency',
    iban: 'IBAN',
    invoicing: 'Invoicing',
    decimalPlaces: 'Decimal Places',
    invoicesPrefix: 'Invoices Prefix',
    currentInvoiceNumber: 'Current Invoice Number',
    creditNotesPrefix: 'Credit Notes Prefix',
    currentCreditNoteNumber: 'Current Credit Note Number',
    lastInvoiceDate: 'Last Invoice Date',
    noInvoicesYet: 'No invoices created yet.',
    confirmReverting: 'Confirm Reverting System',
    allInvoicesAfter: 'All the invoices and their storno issued after',
    willBeRemoved: 'will be removed. Continue with reverting the system?',
    cancel: 'Cancel',
    revert: 'Revert',
    revertDesc: 'Reverting the system will erase all invoices created after the selected date.',
    revertToDate: 'Revert to this date',
    reverting: 'Reverting system, please wait...',
    useOrderNumbering: 'Use order numbering',
    showVat: 'Show VAT on invoices',
    overrideTaxes: 'Override Taxes',
    pricesIncludeTax: 'Prices have tax included',
    productsTaxRate: 'Products Tax Rate',
    shippingTaxRate: 'Shipping Tax Rate',
    skusSeparated: 'SKUs separated by semicolon',
    skusTaxRate: 'SKUs Tax Rate',
    useOrderDates: 'Use order creation dates for invoices',
    convertCurrency: 'Convert prices to the currency in which customer pays',
    unsavedChanges: 'Unsaved changes',
    discard: 'Discard',
    save: 'Save',
  },
  drafts: {
    pageTitle: 'Drafts',
    pageDescription: 'Manage your draft orders',
    title: 'Drafts',
    download: 'Download',
    newDraft: 'New Draft',
    exporting: 'Exporting {status}%...',
    accessNotGranted: 'Draft Orders access not granted. Please',
    reLogin: 're-login',
    toGrantPermissions: 'to grant the required "Draft Orders" permissions.',
    pushFailed: 'Push to Shopify failed:',
    exportError: 'Export error:',
    confirmDelete: 'Are you sure you want to delete this draft?',
    incompleteCustomer: 'Customer data is incomplete:',
    pushWithoutCustomer: 'The draft will be pushed to Shopify without customer data. Continue?',
    customerNotInShopify: 'This customer does not exist in Shopify yet.',
    warnings: 'Warnings:',
    createCustomerAndPush: 'Create the customer in Shopify and push the draft order?',
    downloadTitle: 'Download Drafts',
    cancel: 'Cancel',
  },
  draftEdit: {
    number: "Number",
    prefix: "Prefix",

    pageTitle: 'Edit Draft',
    pageDescription: 'Edit a draft order',
    newDraft: 'New Draft',
    editDraft: 'Edit Draft',
    viewInShopify: 'View in Shopify',
    back: 'Back',
    createDraft: 'Create Draft',
    saveChanges: 'Save Changes',
    documentType: 'Document Type',
    draftOrder: 'Draft Order',
    quote: 'Quote',
    proforma: 'Proforma',
    manualInvoice: 'Manual Invoice',
    currency: 'Currency',
    expiryDate: 'Expiry Date',
    status: 'Status',
    draft: 'Draft',
    sent: 'Sent',
    accepted: 'Accepted',
    customer: 'Customer',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    company: 'Company',
    taxId: 'Tax ID',
    billingAddress: 'Billing Address',
    address: 'Address',
    aptSuite: 'Apt/Suite',
    city: 'City',
    province: 'Province',
    countryField: 'Country',
    zip: 'Zip',
    shippingAddress: 'Shipping Address',
    sameAsBilling: 'Same as billing',
    lineItems: 'Line Items',
    shipping: 'Shipping',
    shippingTitle: 'Title',
    shippingPlaceholder: 'e.g. Standard Shipping',
    price: 'Price',
    note: 'Note',
    notePlaceholder: 'Internal note or message to customer...',
    summary: 'Summary',
    subtotal: 'Subtotal',
    discounts: 'Discounts',
    tax: 'Tax',
    total: 'Total',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Enter your shop address',
    loginWith: 'Login with',
    createAccount: 'Create a new account',
    placeholder: 'your-shop-name',
    shopRequired: 'Shop name is required',
    login: 'Login',
    shopify: 'Shopify',
    terms: 'Terms & Conditions',
    privacy: 'Privacy Policy',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Enjoying Invoice Browse?',
    description: "You've created your first invoices! If you're finding the app useful, a quick review on the Shopify App Store helps us a lot.",
    reward: "As a thank you, we'll reset your monthly usage counter to 0",
    leaveReview: 'Leave a Review',
    maybeLater: 'Maybe later',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Welcome to Invoice Browse',
    welcomeContent: 'Let me show you how you can use it.',
    dashboardTitle: 'Dashboard',
    dashboardContent: 'The screen you are seeing is the main dashboard. Here you can find all orders and you can export them to different document types like: invoices, packing slip and others.',
    automationTitle: 'Make your life easier',
    automationContent: 'Enable automation to create invoices whenever orders are paid or refunded.',
    templatesTitle: 'Customize templates',
    templatesContent: 'Enter here to translate your template, customize it or create a new one.',
    deliveryTitle: 'Delivery',
    deliveryContent: 'Configure our app to automatically copy created documents to FTP, Google Drive, or as attachments for emails.',
    settingsTitle: 'Settings',
    settingsContent1: 'Adjust company phone number, email and other fields used on documents.',
    settingsContent2: 'Change document starting number or erase documents created after a date.',
    settingsContent3: 'Override VAT rates for shipping and products',
    settingsContent4: 'Change decimal places for numbers',
    reviewTitle: 'Write a review',
    reviewContent: 'Support our team by writing us a good review!',
    tourTitle: 'Welcome tour',
    tourContent: 'Hey, you can open this tour again from here.',
    createDocTitle: 'Create your first document',
    createDocContent: 'Click on Create button to create your first document.',
    docNumberTitle: 'Document number',
    docNumberContent: 'First document has number 1 allocated. If you like to start with other number you can change this from Settings.',
    downloadDocTitle: 'Download document',
    downloadDocContent: 'Click on Download drop down and select a document template to export your order as PDF.',
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    discard: 'Discard',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    loading: 'Loading...',
    unsavedChanges: 'Unsaved changes',
    upgradePlan: 'Upgrade your plan',
  },
  selectPhotoDialog: {
    title: 'Select Image',
    clickToSelect: 'Click on an image to set it as logo.',
    noPhoto: 'No photos available. Upload a photo to get started.',
    upload: 'Upload Photo',
    add: 'Add Photo',
    close: 'Close',
    submit: 'Upload',
  },
  draftList: {
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    type: 'Type',
    customer: 'Customer',
    total: 'Total',
    status: 'Status',
    delivered: 'Delivered',
    date: 'Date',
    actions: 'Actions',
    noCustomer: 'No Customer',
    noDrafts: 'No drafts or quotes found.',
    loading: 'Loading...',
    download: 'Download',
    default: 'Default',
    pending: 'Pending',
    deliverNow: 'Deliver now',
    deliveryDetails: 'Delivery Details',
    sent: 'Sent',
    failed: 'Failed',
    deliverAgain: 'Deliver Again',
    partial: 'Partial',
    notDelivered: 'Not Delivered',
    deliveryFailed: 'Delivery Failed',
    unknown: 'Unknown',
    edit: 'Edit',
    send: 'Send',
    pushToShopify: 'Push to Shopify',
    complete: 'Complete',
    duplicate: 'Duplicate',
    delete: 'Delete',
    quote: 'Quote',
    proforma: 'Proforma',
    draftOrder: 'Draft Order',
    manualInvoice: 'Manual Invoice',
  },
  draftSearch: {
    createdBtw: 'Created btw.',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Customer',
    status: 'Status',
    type: 'Type',
    delivery: 'Delivery',
    any: 'Any',
    draft: 'Draft',
    sent: 'Sent',
    accepted: 'Accepted',
    expired: 'Expired',
    converted: 'Converted',
    cancelled: 'Cancelled',
    quote: 'Quote',
    proforma: 'Proforma',
    draftOrder: 'Draft Order',
    manualInvoice: 'Manual Invoice',
    delivered: 'Delivered',
    notDelivered: 'Not Delivered',
    pending: 'Pending',
    search: 'Search',
  },
  draftDownload: {
    title: 'Download Drafts & Quotes...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Status',
    documentType: 'Document Type',
    any: 'Any',
    draft: 'Draft',
    sent: 'Sent',
    accepted: 'Accepted',
    expired: 'Expired',
    converted: 'Converted',
    cancelled: 'Cancelled',
    quote: 'Quote',
    proforma: 'Proforma',
    draftOrder: 'Draft Order',
    manualInvoice: 'Manual Invoice',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  languageSelector: {
    label: 'Language',
    auto: 'Auto-detect',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Install new template',
    // Tabs
    tabStyle: 'Style',
    tabContent: 'Content',
    tabTranslations: 'Translations',
    tabSettings: 'Settings',
    tabCode: 'Code',
    tabCopilot: 'AI Copilot',
    // Style tab
    logo: 'Logo',
    colorPalette: 'Color Palette',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    // Content tab
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    // Translations tab
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    // Paper/Settings tab
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    // Code tab
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    // Copilot tab
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/en.js